import React, { useCallback, useEffect, useState, useRef, memo } from 'react';
const testimonials = [{
  name: 'Lucas G.',
  location: 'Córdoba',
  role: 'Estudiante de Medicina — 3er año UNC',
  avatar: 'https://images.unsplash.com/photo-1618498082410-b4aa22193b38?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Tenía parcial de Anatomía en 3 días y no entendía nada del plexo braquial. Abrí el Tomo 2, busqué el capítulo, y en 40 minutos tenía todo claro con la mnemotecnia incluida. Saqué un 8. Primera vez que no recurso.',
  time: '22:14',
  reply: 'Eso es exactamente para lo que está pensado 🙌 Cuando el contenido está ordenado y con recursos mnemotécnicos, el parcial deja de ser un drama.'
}, {
  name: 'Sofía V.',
  location: 'Buenos Aires',
  role: 'Estudiante de Medicina — 4to año UBA',
  avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'El Checklist de Final del Bono 4 es un cheat code. Repasé los 50 temas de Anatomía oral antes del final y el 70% de lo que preguntaron estaba ahí. Aprobé con 7 sin haber ido a todas las clases.',
  time: '11:30',
  reply: 'Me alegra un montón 😄 Ese checklist está armado con lo que más toman los docentes de anatomía. Bien que lo aprovechaste.'
}, {
  name: 'Martina P.',
  location: 'Rosario',
  role: 'Estudiante de Medicina — 3er año UNR',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Me trabé con farmacocinética. Abrí el Tomo 4 y encontré el esquema exacto que necesitaba con ejemplos clínicos. Lo entendí en 20 minutos y lo expliqué en el oral sin problemas. Me pusieron un 9.',
  time: '16:52',
  reply: 'Qué bueno 🥹 El Tomo 4 está pensado para que farmaco deje de ser un monstruo. Seguí así.'
}, {
  name: 'Agustín R.',
  location: 'Tucumán',
  role: 'Estudiante de Medicina — 5to año UNT',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Estaba en el peor momento de la carrera. Tres finales juntos, guardia y sin plata para clases particulares. El Tomo 5 de clínica me salvó el cuatrimestre. Todo lo que necesitaba para la historia clínica en un solo lugar.',
  time: '09:03',
  reply: 'Esa situación es muy real y muy difícil 😔 Me alegra que hayas encontrado lo que necesitabas. Ya falta poco para terminar.'
}, {
  name: 'Valentina M.',
  location: 'Mendoza',
  role: 'Estudiante de Medicina — 4to año UNCuyo',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'El Bono de Mnemotecnia es lo que debería darte la facultad el primer día. Tenía todos los nervios craneales, huesos del carpo y plexos memorizados en una sola tarde. Dejé de buscar en 5 libros distintos.',
  time: '19:27',
  reply: 'Exacto, para eso está 😊 Que todo esté en un lugar te ahorra tiempo y energía para lo que importa: entender y aprobar.'
}, {
  name: 'Ignacio H.',
  location: 'Santa Fe',
  role: 'Estudiante de Medicina — 3er año UNL',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Le tenía miedo al final de Fisiología. Es la materia que más recursa en mi facultad. Usé el Tomo 3 completo con el plan de estudio 2-4-8. Aprobé de primera con un 8. No lo puedo creer todavía.',
  time: '14:11',
  reply: 'Creelo, te lo ganaste 💪 Fisiología asusta porque es mucho contenido. El Tomo 3 + el sistema de estudio está hecho para ordenar exactamente eso.'
}, {
  name: 'Camila B.',
  location: 'Salta',
  role: 'Estudiante de Medicina — 2do año UCASAL',
  avatar: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Soy más de estudiar con ejemplos que con teoría pura. El Tomo 1 tiene el método de estudio explicado desde cero. Active Recall, Anki, todo con pasos concretos. Primera vez que entiendo cómo estudiar Medicina de verdad.',
  time: '21:05',
  reply: 'Eso marca toda la diferencia 😌 Cuando tenés un método claro, el contenido se asienta mucho mejor. Esa es la idea detrás de cada tomo.'
}];
function ChevronLeft() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-361">
      <path d="M15 18l-6-6 6-6" data-id="element-362" />
    </svg>;
}
function ChevronRight() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-363">
      <path d="M9 18l6-6-6-6" data-id="element-364" />
    </svg>;
}
const WhatsAppChat = memo(function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-365">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-366">
        <div className="relative" data-id="element-367">
          <img src={t.avatar} alt={t.name} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-368" />
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-369" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-370">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-371">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-372">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-373">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-374">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-375" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 min-h-[160px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a'
    }} data-id="element-376">
        {/* Incoming bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-377">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-378" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-379">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-380">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-381">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-382">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-383">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-384" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-385" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble — celeste médico en lugar de verde */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-386">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #0369a1',
          borderRight: '8px solid transparent'
        }} data-id="element-387" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#0369a1'
        }} data-id="element-388">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-389">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-390">
              <span className="text-xs" style={{
              color: '#bae6fd'
            }} data-id="element-391">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-392">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bae6fd" data-id="element-393" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bae6fd" data-id="element-394" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-395">
        <div style={{
        color: '#8696a0'
      }} data-id="element-396">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-397">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-398" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-399">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-400">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-401">
            <path d="M12 15c1.66 0 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-402" />
          </svg>
        </div>
      </div>
    </div>;
});
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setSlideDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 250);
  }, [isAnimating]);
  const next = useCallback(() => {
    goTo((current + 1) % total, 'left');
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'right');
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    background: 'linear-gradient(180deg, rgb(224,242,254) 0%, rgb(240,249,255) 85%, rgb(224,242,254) 100%)'
  }} data-id="element-403">
      <div className="mx-auto max-w-2xl" data-id="element-404">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-405">
          Lo que dicen los estudiantes{' '}
          <span style={{
          color: '#0284c7'
        }} data-id="element-406">que ya lo usan:</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-407">
          +1.800 estudiantes de todo el país ya tienen la carrera de Medicina
          organizada.
        </p>

        {/* Carousel */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-408">
          {/* Arrow prev */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-0 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#0284c7',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-409">
            <ChevronLeft data-id="element-410" />
          </button>

          {/* Arrow next */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-0 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#0284c7',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-411">
            <ChevronRight data-id="element-412" />
          </button>

          {/* Card */}
          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-413">
            <div style={{
            transition: isAnimating ? 'none' : 'opacity 0.25s ease, transform 0.25s ease',
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating ? `translateX(${slideDirection === 'left' ? '-30px' : '30px'})` : 'translateX(0)'
          }} data-id="element-414">
              <WhatsAppChat t={testimonials[current]} data-id="element-415" />
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgb(226,232,240)'
        }} data-id="element-416">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#0284c7',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-417" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-418">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'left' : 'right')} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#0284c7' : 'rgb(203,213,225)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-419" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs text-gray-400" data-id="element-420">
            {current + 1} / {total}
          </p>
        </div>
      </div>

      {/* Degradé de integración con FAQ */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(240,249,255) 100%)'
    }} data-id="element-421" />
    </section>;
}